export enum TextMessageStatus {
  Created,
  Sent,
  Failed
}
